/* global Homie */
import LoaderPopup from '../../shared/libs/LoaderPopup';
import axios from 'axios';

export default {
	template: '#auth-confirmation',
	props: ['title', 'callback'],
	data() {
		return {
			mobile_phone_backup: null,
			country_code: 52,
			show_contry_codes: false,
			user: {
				name: Homie.user.name,
				last_name: Homie.user.last_name,
				second_last_name: Homie.user.second_last_name,
				mobile_phone: Homie.user.mobile_phone,
				email: Homie.user.email,
			},			
			error: false,
			role: Homie.onboardingRole
		}
	},
	computed: {
		isDesktop(){
			return $(window).width() >= 768;
		}
	},
	mounted(){
		$('.steps-list').hide();
		$('html, body').animate({scrollTop: 0}, 250);
		if(Homie.user.mobile_phone){
			this.redirect();				
		}
	},
	destroyed(){
		$('.steps-list').show();
	},
	methods: {
		showCountryCodes() {
			this.show_contry_codes = true;
		},
		hideCountryCodes() {
			this.show_contry_codes = false;
		},
		getRegistered(e) {
			this.$validator.validateAll().then((formValid) => {
				if(formValid){
					this.mobile_phone_backup = this.user.mobile_phone;
					this.user.mobile_phone = `+${this.country_code}${this.user.mobile_phone}`;
					this.submit(e);
				}else{
					Homie.Handlers.LayoutHandler.showFlashMessage('Hay errores en el formulario. Por favor verifica y vuelve a intentar','error');
				}
			}).catch(() => {
			});
		},
		submit(e) {
			LoaderPopup.show();
			axios.put('/users.json', this.$data)
				.then(response => {
					Homie.user = response.data.user;
					LoaderPopup.hide();
					this.redirect();					
				})
				.catch(error => {
					this.user.mobile_phone = this.mobile_phone_backup;
					LoaderPopup.hide();
					this.error = error.response.data.message || 'Error en el registro';
					this.$swal({title: '', text: this.error, timer: 5000}).catch(this.$swal.noop);
				})
		},
		goToCallback(){
			let resolvedLocation = this.$router.resolve({name: this.callback });
			if(resolvedLocation){
				this.$router.push({name: this.callback});
			}else{
				window.location.href = this.callback;
			}
		},
		redirect(){
			if(this.callback){
				this.$router.push({name: this.callback});
			}else{
				window.location.href = '/';
			}
		}		
	}
}